import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function MeContacter() {
  return (
    <>
      <motion.a
        whileHover="hover"
        href="/contact"
        className="inline-flex items-center px-4 py-2 bg-rose text-white rounded-full hover:bg-blue transition duration-300 mx-2"
        aria-label="Contacter par email"
        title="Contacter par email">
        <motion.div
          className="mr-2"
          variants={{
            rest: { rotate: 0 },
            hover: {
              rotate: 360,
              transition: { duration: 0.6 },
            },
          }}>
          <FontAwesomeIcon icon={faEnvelope} />
        </motion.div>
        Me Contacter
      </motion.a>
    </>
  );
}
